// @flow
import React from 'react';
import styled from 'styled-components';

const StyledLoader = styled.div`
    text-align: center;
    padding: 80px 0 0 0;
    width: 100%;

    & .message {
        margin: 0;
    }
`;

type loaderProps = {
    message: string,
};

const Loader = (props: loaderProps) => {
    const { message } = props;

    return (
        <StyledLoader>
            <p className="message">
                {message || 'Loading, please wait...'}
            </p>
        </StyledLoader>
    );
};

export default Loader;



// WEBPACK FOOTER //
// ./src/components/Loader/Loader.js